export const main = {
    'load-backup': "Les patients de la journée ont été chargés. En cas de problème de connexion, vous pourrez tout de même consulter ces dossiers.",
    logout: "Vous avez été déconnecté !"
}